/**
 * Класс для управления динамическим полем select в приложении
 * @package DynamicFieldClass
 * @version 1.0
 * @author BOLOTOV I.P.
 * @since 17.08.2022
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */
import {ISelect} from '../interfaces/Select.interface';
import {SelectServiceLib} from './SelectServiceLib.service';
import {Select} from './Select.class';
import {takeUntil} from 'rxjs/operators';
import {FormControl} from '@angular/forms';
import {Inject, Injectable, OnInit} from '@angular/core';
import {InterfaceAppServiceRegister} from '@app/app.interface';
import {TuiDestroyService} from '@taiga-ui/cdk';

@Injectable()
/** Класс для управления динамическим полем select */
export abstract class SelectSearch extends Select implements ISelect, OnInit {
    /** Constructor */
    protected constructor(
        @Inject(TuiDestroyService) protected _destroy$: TuiDestroyService,
        service: SelectServiceLib
    ) {
        super(_destroy$, service);
    }

    /** Элемент фильтра (строка фильтра) */
    filterCtrl: FormControl = new FormControl();

    ngOnInit() {
        this.setOptions(this.service.field.options as InterfaceAppServiceRegister[]);
        this.filterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                if (this.service.options && this.service.options.length > 0) {
                    this.filterSelect();
                }
            });
        setTimeout(() => {
            this.matSelect._overlayPanelClass += 'custom-select-panel';
        });
    }

    /** Фильтр для поиска в селекте */
    private filterSelect(): void {
        // Получение значения строки поиска.
        const searchStr = this.filterCtrl.value;
        if (!searchStr) {
            this.filteredSelect.next(this.service.options.slice());
            return;
        }
        const matchValue = new RegExp(
            searchStr
                .toLowerCase()
                .replace(/[еёЕЁ]/g, '[еёЕЁ]'), 'i');
        // Организация фильтрованного массива
        this.filteredSelect.next(
            this.service.options.filter(value => {
                try {
                    return value.name.match(matchValue);
                } catch (e) {
                    return false;
                }
            })
        );
    }

    /**
     * Установка опций select
     * @param options - набор опций
     */
    setOptions(options: InterfaceAppServiceRegister[]): void {
        this.service.options = [];
        this.service.fieldValue = {};
        const fieldValue = String(this.service.group?.get(this.service.field.name)?.value);
        options.forEach(value => {

            const isDel = value?.is_del;

            if (typeof isDel === 'undefined'
                ||
                (typeof isDel !== 'undefined' && (!isDel || isDel == '0'))) {
                this.service.options.push(value);
            } else if (typeof isDel !== 'undefined'
                && (isDel === true || isDel == '1')
                && (fieldValue == value.id || fieldValue.indexOf(String(value.id)) !== -1)) {
                this.service.options.push(value);
                this.service.fieldValue[value.id] = value;
            }
        });
        this.filteredSelect.next(this.service.options.slice());
    }
}
